export const SPACE_CATEGORY = {
  collaborative: 0,
  individual: 1,
  community: 2,
  support: 3
};

const SPACE_TYPE = {
  enclosed: 0,
  open: 1,
  openEnclosed: 2
};

export const SPACE_TYPE_LABEL = {
  [SPACE_TYPE.enclosed]: 'Enclosed',
  [SPACE_TYPE.open]: 'Open',
  [SPACE_TYPE.openEnclosed]: 'Open/Enclosed'
};

export const SPACE_AGGREGATE = {
  workstation: 0
};
